import { DeliveryPreference } from '../../models/DeliveryPreference';
import { RootState } from '../store';

export const selectDeliveryPreference = (state: RootState): DeliveryPreference | null => {
  if (!state.deliveryPreference?.data) return null;
  return state.deliveryPreference?.data;
};

export const selectDeliveryPreferenceLoading = (state: RootState): boolean | null => {
  return state.deliveryPreference?.loading || null;
};
